import React, { Component } from "react";

export default class ContactForm extends Component {
  componentWillMount() {
    const submission = {};
    for (let i = 0; i < this.props.fields.length; i++) {
      submission[this.props.fields[i].name] = "";
    }
    this.setState({ submission: submission });
  }

  handleChange = (type, event) => {
    event.preventDefault();
    const submission = this.state.submission;
    submission[type] = event.target.value;
    this.setState({ submission: submission });
  };

  handleSubmit = (event) => {
    event.preventDefault();

    // Check if valid
    let valid = true;
    for (let i = 0; i < this.props.fields.length; i++) {
      if (this.props.fields[i].valid) {
        if (
          !this.props.fields[i].valid(
            this.state.submission[this.props.fields[i].name]
          )
        ) {
          this.setState({ [`input${i}`]: true });
          valid = false;
        }
      }
    }
    if (valid) {
      this.props.submit(this.state.submission);
    }
  };

  render() {
    const fields = [];
    for (let i = 0; i < this.props.fields.length; i++) {
      fields.push(
        <label
          key={i}
          className={this.props.fields[i].size == "big" ? "big" : ""}
        >
          <p className={this.props.submitted ? "submitted" : ""}>
            {this.props.fields[i].label}
          </p>
          {this.props.fields[i].size == "big" ? (
            this.props.fields[i].required ? (
              <textarea
                className={
                  this.state[`input${i}`]
                    ? this.props.fields[i].valid(
                        this.state.submission[this.props.fields[i].name]
                      )
                      ? "valid"
                      : "invalid"
                    : ""
                }
                type={
                  this.props.fields[i].type
                    ? this.props.fields[i].label
                    : "text"
                }
                value={this.state.submission[this.props.fields[i].name]}
                onChange={(e) =>
                  this.handleChange(this.props.fields[i].name, e)
                }
                style={{
                  height:
                    this.state.submission[this.props.fields[i].name].length >
                    300
                      ? "20rem"
                      : "10rem",
                }}
                onBlur={() => this.setState({ [`input${i}`]: true })}
                required
              />
            ) : (
              <textarea
                ref={(el) => (this[`input${i}`] = el)}
                type={
                  this.props.fields[i].type
                    ? this.props.fields[i].label
                    : "text"
                }
                value={this.state.submission[this.props.fields[i].name]}
                onChange={(e) =>
                  this.handleChange(this.props.fields[i].name, e)
                }
                style={{
                  height:
                    this.state.submission[this.props.fields[i].name].length >
                    300
                      ? "20rem"
                      : "10rem",
                }}
                onBlur={() =>
                  this.state.submission[this.props.fields[i].name].length > 0
                    ? this[`textarea${i}`].classList.add("valid")
                    : (this[`textarea${i}`].className = "")
                }
              />
            )
          ) : this.props.fields[i].required ? (
            <input
              className={
                this.state[`input${i}`]
                  ? this.props.fields[i].valid(
                      this.state.submission[this.props.fields[i].name]
                    )
                    ? "valid"
                    : "invalid"
                  : ""
              }
              type={
                this.props.fields[i].type ? this.props.fields[i].label : "text"
              }
              value={this.state.submission[this.props.fields[i].name]}
              onChange={(e) => this.handleChange(this.props.fields[i].name, e)}
              onBlur={() => this.setState({ [`input${i}`]: true })}
              required
            />
          ) : (
            <input
              ref={(el) => (this[`input${i}`] = el)}
              type={
                this.props.fields[i].type ? this.props.fields[i].label : "text"
              }
              value={this.state.submission[this.props.fields[i].name]}
              onChange={(e) => this.handleChange(this.props.fields[i].name, e)}
              onBlur={() =>
                this.state.submission[this.props.fields[i].name].length > 0
                  ? this[`input${i}`].classList.add("valid")
                  : (this[`input${i}`].className = "")
              }
            />
          )}
        </label>
      );
    }

    return (
      <form
        className={
          this.props.submitted
            ? "contact-form margin-bottom submitted"
            : "contact-form margin-bottom"
        }
        onSubmit={this.handleSubmit}
        noValidate
      >
        {fields}
        <input
          type="submit"
          className={this.props.submitted ? "submitted" : ""}
          value="Send Message"
        />
      </form>
    );
  }
}
